import api from './api';

const costService = {
  // Buscar todos os custos
  getAllCosts: async (params = {}) => {
    try {
      const response = await api.get('/costs', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar custos:', error);
      throw error;
    }
  },

  // Buscar custo por ID
  getCostById: async (id) => {
    try {
      const response = await api.get(`/costs/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar custo:', error);
      throw error;
    }
  },

  // Criar novo custo
  createCost: async (costData) => {
    try {
      console.log('🟢 [SERVICE] createCost chamado');
      console.log('🟢 [SERVICE] costData enviado:', JSON.stringify(costData, null, 2));
      console.log('🟢 [SERVICE] cost_type no costData:', costData.cost_type);
      const response = await api.post('/costs', costData);
      console.log('🟢 [SERVICE] Resposta recebida:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao criar custo:', error);
      throw error;
    }
  },

  // Atualizar custo
  updateCost: async (id, costData) => {
    try {
      const response = await api.put(`/costs/${id}`, costData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar custo:', error);
      throw error;
    }
  },

  // Deletar custo
  deleteCost: async (id) => {
    try {
      const response = await api.delete(`/costs/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar custo:', error);
      throw error;
    }
  },

  // Deletar múltiplos custos
  bulkDeleteCosts: async (ids) => {
    try {
      const response = await api.post('/costs/bulk-delete', { ids });
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar custos em massa:', error);
      throw error;
    }
  },

  // Buscar histórico de preços
  getPriceHistory: async (id) => {
    try {
      const response = await api.get(`/costs/${id}/history`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar histórico:', error);
      throw error;
    }
  },

  // Buscar margens de lucro
  getProfitMargins: async () => {
    try {
      const response = await api.get('/costs/margins/profit');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar margens:', error);
      throw error;
    }
  },

  // Atualizar margem de lucro
  updateProfitMargin: async (category, marginPercentage) => {
    try {
      const response = await api.put(`/costs/margins/profit/${category}`, {
        margin_percentage: marginPercentage
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar margem:', error);
      throw error;
    }
  },

  // Buscar estatísticas de custos
  getCostStats: async (params = {}) => {
    try {
      const response = await api.get('/costs/stats', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      throw error;
    }
  },

  // Buscar funcionários ativos
  getActiveEmployees: async () => {
    try {
      const response = await api.get('/costs/employees');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar funcionários:', error);
      throw error;
    }
  },

  // === CUSTOS OPERACIONAIS COM RECORRÊNCIA ===

  // Listar custos operacionais
  getOperationalCosts: async (params = {}) => {
    try {
      const response = await api.get('/costs/operational', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar custos operacionais:', error);
      throw error;
    }
  },

  // Listar custos que vencem hoje
  getDueCosts: async () => {
    try {
      const response = await api.get('/costs/due');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar custos vencidos:', error);
      throw error;
    }
  },

  // Sincronizar um custo para o financeiro
  syncCostToFinance: async (id) => {
    try {
      const response = await api.post(`/costs/operational/${id}/sync`);
      return response.data;
    } catch (error) {
      console.error('Erro ao sincronizar custo:', error);
      throw error;
    }
  },

  // Sincronizar todos os custos vencidos
  syncAllDueCosts: async () => {
    try {
      const response = await api.post('/costs/sync-all');
      return response.data;
    } catch (error) {
      console.error('Erro ao sincronizar custos:', error);
      throw error;
    }
  },

  // Notificações de despesas recorrentes
  checkDueCosts: async () => {
    try {
      const response = await api.post('/costs/recurring/check-due');
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar custos vencidos:', error);
      throw error;
    }
  },

  getRecurringPending: async (params = {}) => {
    try {
      const queryParams = {};
      if (params.status) queryParams.status = params.status;
      if (params.month) queryParams.month = params.month;
      if (params.year) queryParams.year = params.year;
      const response = await api.get('/costs/recurring/pending', { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pendentes:', error);
      throw error;
    }
  },

  confirmRecurringCost: async (id, data = {}) => {
    try {
      const response = await api.post(`/costs/recurring/${id}/confirm`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao confirmar pagamento:', error);
      throw error;
    }
  },

  // CRUD despesas recorrentes
  createRecurringCost: async (costData) => {
    try {
      const response = await api.post('/costs/recurring', costData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar despesa recorrente:', error);
      throw error;
    }
  },

  getRecurringCosts: async (params = {}) => {
    try {
      const response = await api.get('/costs/recurring', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar despesas recorrentes:', error);
      throw error;
    }
  },

  updateRecurringCost: async (id, costData) => {
    try {
      const response = await api.put(`/costs/recurring/${id}`, costData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar despesa recorrente:', error);
      throw error;
    }
  },

  deleteRecurringCost: async (id) => {
    try {
      const response = await api.delete(`/costs/recurring/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar despesa recorrente:', error);
      throw error;
    }
  },

  // Buscar parcelas de uma despesa recorrente
  getRecurringCostParcels: async (costId) => {
    try {
      const response = await api.get(`/costs/recurring/${costId}/parcels`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar parcelas:', error);
      throw error;
    }
  },
  getCostsWithAbates: async (params = {}) => {
    try {
      const response = await api.get('/costs/with-abates', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar custos com abates:', error);
      throw error;
    }
  },
  getCostAbates: async (costId) => {
    try {
      const response = await api.get(`/costs/${costId}/abates`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar abates do custo:', error);
      throw error;
    }
  },
  payCostByCompany: async (costId, paymentData) => {
    try {
      const response = await api.post(`/costs/${costId}/pay-by-company`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Erro ao quitar despesa pela empresa:', error);
      throw error;
    }
  },
  // Subpedidos e períodos de pedidos customizados
  getSubOrders: async (costId) => {
    try {
      const response = await api.get(`/costs/${costId}/sub-orders`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar subpedidos:', error);
      throw error;
    }
  },
  addSubOrder: async (costId, data) => {
    try {
      const response = await api.post(`/costs/${costId}/sub-orders`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar subpedido:', error);
      throw error;
    }
  },
  confirmSubOrderStock: async (costId, subOrderId, data) => {
    try {
      const response = await api.post(`/costs/${costId}/sub-orders/${subOrderId}/confirm`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao confirmar subpedido no estoque:', error);
      throw error;
    }
  },
  updateItemInspectionStatus: async (itemId, data) => {
    try {
      const response = await api.patch(`/costs/items/${itemId}/inspection`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status de conferência do item:', error);
      throw error;
    }
  },
  getCustomCostItems: async (costId) => {
    try {
      const response = await api.get(`/costs/${costId}/items`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar itens da despesa personalizada:', error);
      throw error;
    }
  },
  getSupplierCredits: async (supplierId) => {
    try {
      const response = await api.get(`/costs/suppliers/${supplierId}/credits`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar créditos do fornecedor:', error);
      throw error;
    }
  },
};

export default costService;
